import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getRowHeightBasedOnContent } from '@client-shared/ui-agGrid';

import {
  beginningBalancesPropType,
  companyCodePropType,
  validationSummaryPropType,
} from './propTypes';

import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import {
  beginningBalancesColumnDefsTpc,
  beginningBalancesColumnDefsEsdrm,
  importValidationColumnDefinition,
} from '../../shared/columnDefinitions/beginningBalances';
import ValidationSummaryHeader from '../../shared/validationSummaryHeader.component';

import { BookTypePills, BookTypePillTypes } from '../../shared/bookTypePills';
import { YES_FLAG } from '../../shared/constants';
import { PureAlert } from '../../shared/alert.component';

class BeginningBalancesGrid extends PureComponent {
  static propTypes = {
    companyCode: companyCodePropType.isRequired,
    beginningBalances: PropTypes.arrayOf(beginningBalancesPropType).isRequired,
    beginningBalancesLoading: PropTypes.bool.isRequired,
    activePill: PropTypes.string.isRequired,
    validationSummary: validationSummaryPropType,
    importIgnoredCompanyCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  selectFirstRow = params => {
    const firstRow = params.api.getModel().getRow(0);

    if (firstRow) {
      const deselectOthers = true;
      firstRow.setSelected(true, deselectOthers);
    }
  };

  onRowDataUpdated = params => {
    if (params.gridApi) {
      params.gridApi.applyColumnState({
        state: [
          { colId: 'importValidation', sort: 'desc' },
        ],
      });
      params.gridApi.autoSizeAllColumns();
      this.selectFirstRow(params);
    }
  };

  render() {
    const {
      companyCode,
      beginningBalances,
      beginningBalancesLoading,
      activePill,
      validationSummary,
      importIgnoredCompanyCodes,
    } = this.props;

    const filteredBeginningBalances = beginningBalances.filter(beginningBalance => {
      switch (activePill) {
        case BookTypePillTypes.GAAP:
          return beginningBalance.bookType === 'P';
        case BookTypePillTypes.GAAP_TO_STAT:
          return beginningBalance.bookType === 'G';
        default:
          return true;
      }
    });

    const hasImportValidationsErrors = filteredBeginningBalances
      .some(beginningBalance => beginningBalance.importStatusDetail === -1);
    const columnDefs = companyCode?.chartName === 'R2R' ? beginningBalancesColumnDefsEsdrm : beginningBalancesColumnDefsTpc;

    return (
      <div>
        <ValidationSummaryHeader
          className="beginning-balance-tab-header"
          entityName="1-1 Balance"
          validationSummary={validationSummary}
          shouldDisplayZero
        />
        { importIgnoredCompanyCodes.length > 0 && (
          <PureAlert
            type="alert-info "
            content={`Company Code records not imported in the last import file: ${ importIgnoredCompanyCodes.join(', ')}`}
            show
          />
        )}
        <div className="ag-grid-full-page-with-secondary-menu">
          <AgGrid
            columnDefs={hasImportValidationsErrors ? [importValidationColumnDefinition].concat(columnDefs) : columnDefs}
            headerHeight={50}
            rowData={filteredBeginningBalances}
            onRowDataUpdated={this.onRowDataUpdated}
            isGridLoading={beginningBalancesLoading}
            getRowHeight={getRowHeightBasedOnContent({
              field: 'IMPORT_VALIDATION',
              margins: 8,
              lineHeight: 17,
              extraLength: 12,
              averageCharsInLine: 30,
            })}
            withSearchBar
          />
        </div>
      </div>
    );
  }
}

export default withPillNavigation(
  ({ companyCode }) => {
    if (companyCode?.statCalc === YES_FLAG) {
      return BookTypePills;
    }

    return BookTypePills.filter(pill => pill.type === BookTypePillTypes.GAAP);
  },
  {
    propTypes: {
      companyCode: companyCodePropType.isRequired,
    },
    className: 'page-content-container',
  }
)(BeginningBalancesGrid);
